import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="reorder-toggle"
export default class extends Controller {
  static targets = ["button", "knob"]

  connect() {
    this.enabled = false
  }

  toggle() {
    this.enabled = !this.enabled

    this.buttonTarget.setAttribute("aria-checked", this.enabled)
    this.buttonTarget.classList.toggle("bg-indigo-600", this.enabled)
    this.buttonTarget.classList.toggle("bg-gray-200", !this.enabled)
    this.knobTarget.classList.toggle("translate-x-5", this.enabled)
    this.knobTarget.classList.toggle("translate-x-0", !this.enabled)

    window.dispatchEvent(new CustomEvent("reorder:toggled", { detail: { enabled: this.enabled } }))
  }
}
